module.exports = __webpack_public_path__ + "img/logo_wallet.914516eb.svg";